import "./NextPreviousPhaseButtons.css";

import { ArrowheadLeftLightIcon } from "../../../../../../../assets";
import { ProjectPhase } from "../../../../../../../constants/project-phase";
import { Button } from "../../../../../../../widget";

const calculatePhase = (
  currentPhase: ProjectPhase,
  action: "next" | "previous",
  phaseOrder: ProjectPhase[]
): ProjectPhase | undefined => {
  const index = phaseOrder.findIndex((phase) => phase === currentPhase);

  return phaseOrder[index + (action === "next" ? 1 : -1)];
};

export interface NextPreviousPhaseButtonsProps {
  currentPhase: ProjectPhase;
  handlePhaseChange: (phase: ProjectPhase) => void;
  phaseOrder?: ProjectPhase[];
}

export const NextPreviousPhaseButtons = ({
  currentPhase,
  handlePhaseChange,
  phaseOrder = Object.values(ProjectPhase),
}: NextPreviousPhaseButtonsProps): JSX.Element => {
  const currentPhaseIndex = phaseOrder.findIndex((phase) => phase === currentPhase);
  const previousPhase = calculatePhase(currentPhase, "previous", phaseOrder);
  const nextPhase = calculatePhase(currentPhase, "next", phaseOrder);

  return (
    <div className="NextPreviousPhaseButtonsContainer">
      {currentPhaseIndex > 0 && previousPhase && (
        <Button
          text="Previous"
          variant="tertiary"
          hasNoPadding
          icon={<ArrowheadLeftLightIcon className="ArrowheadLeftBlueIcon" />}
          iconPosition="left"
          onClick={() => handlePhaseChange(previousPhase)}
        />
      )}
      {currentPhaseIndex >= 0 && currentPhaseIndex < phaseOrder.length - 1 && nextPhase && (
        <Button
          text="Next"
          variant="primary"
          hasNoPadding
          icon={<ArrowheadLeftLightIcon className="ArrowheadRightLightIcon" />}
          onClick={() => handlePhaseChange(nextPhase)}
        />
      )}
    </div>
  );
};
